export default __webpack_public_path__ + "static/media/guc_building.e33bfe69.jpg";